// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--bkAUNqP3w4AKI5uv"};